var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { DefaultTheme } from '../../Themes';
const StyledBadgeContainer = styled.div `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  font-size: 1rem;
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default'};
`;
const Badge = (_a) => {
    var { className, children, onClick, title, theme = DefaultTheme } = _a, rest = __rest(_a, ["className", "children", "onClick", "title", "theme"]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledBadgeContainer, Object.assign({ className: className, clickable: !!onClick, onClick: onClick, title: title }, rest), children)));
};
export default Badge;
